export default __webpack_public_path__ + "static/media/company-invoices.c62e2d8e.svg";